import { CircularProgress } from "@mui/material";
import '../PaymentLoader/Loader.scss';

const ButtonLoader = () => {
  return (
    <div className="loader-wrapper">
      <CircularProgress size={30} />
    </div>
  );
};

export default ButtonLoader;